import { UiToast } from 'components';
import { appClient, expression, level } from 'lib';
import roomLib from '../room';
import { globalStore } from 'stores';

import msgService from '../../functions/messages/service';

const handle = (socket) => {
  socket.on('message.chat', (msg, { room }, { messages }) => {
    let { roomId } = room;
    let { data_d: data } = msg;

    if (roomId !== data.room_id) {
      return;
    }

    if (data.levelUp) {
      return;
    }

    if (data.isWarn) {
      UiToast.fail(data.content);
      return;
    }

    // 确定消息内容的大小
    let size = 'sm';
    let isHostUser = roomLib.isHost(data.from._id);
    data.from.isHostUser = isHostUser;
    data.from.isMicStar = roomLib.isMicStar(data.from._id);
    data.from.isAdmin = roomLib.isAdmin(data.from._id);
    data.from.level = level.getRichLevel(data.from.spend).level || 0;
    // 紫p并且有专属表情
    if (
      (data.from.vip === 2 || isHostUser) &&
      expression.hasExp(data.content, 'svip')
    ) {
      size = 'md';
    }

    // 等级12级以上且有等级表情
    if (
      (data.from.level >= 12 || isHostUser) &&
      expression.hasExp(data.content, 'level')
    ) {
      size = 'md';
    }

    data.size = size;

    // 替换表情
    data.content = msgService.renderMsgContent(data);

    // 是否是 @我 的消息
    data.isToMe = false;
    if (data.to) {
      if (globalStore.userInfo && globalStore.userInfo._id === data.to._id) {
        data.isToMe = true;
      }
    }

    data.isShuminChat = false;
    if (data.from._id) {
      if (globalStore.userInfo && globalStore.userInfo._id === data.from._id) {
        data.isShuminChat = false;
      } else {
        if (data.from.spend <= 1000) {
          data.isShuminChat = true;
        }
      }
    }

    messages.add({
      msg,
      msgType: 'chat',
      tabType: 'chat',
    });
  });
};

export default handle;
